module.exports = __webpack_public_path__ + "static/media/google-logo.686f8efa.svg";